// EN
export const availabilityPrices = {
  header: {
    title: "Verfügbarkeit & Raten",
  },
  common: {
    today: "Heute",
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Wird gespeichert…",
  },
  pricelabs: {
    title: "Die Preise werden von PriceLabs verwaltet",
    text: "Die Raten werden automatisch aktualisiert und lassen sich nicht manuell bearbeiten.",
  },
  topbar: {
    calendar: "Kalender",
    bulkEdit: "Sammelbearbeitung",
    configTitle: "Kalendereinstellungen",
    syncSection: "Synchronisierung",
    resyncOta: "Erneut mit OTA synchronisieren",
    resyncOtaDesc: "Sendet Verfügbarkeit und Raten erneut an den Kanal.",
  },
  empty: {
    noHotelTitle: "Keine Inserate vom Typ Hotel",
    noHotelDesc:
      "Legen Sie ein Inserat vom Typ <strong>Hotel</strong> oder <strong>Camping</strong> an, um Verfügbarkeit und Raten zu verwalten.",
    goToListings: "Zu den Inseraten",
    noRoomsTitle: "{name} hat keine Zimmer",
    noRoomsDesc:
      "Für dieses Inserat sind noch keine Zimmer angelegt. Fügen Sie Einheiten in den Details des Inserats hinzu, um Verfügbarkeit und Raten zu verwalten.",
    configureListing: "Inserat einrichten",
  },
  summary: {
    roomState: "Zimmerstatus",
    roomsForSale: "Zimmer im Verkauf",
    netBooked: "Netto gebucht",
  },
  state: {
    available: "Verfügbar",
    closed: "Geschlossen",
    soldOut: "Ausgebucht",
    pastLabel: "k. A.",
  },
  calendar: {
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of rooms / nights
    roomsCount: "{count} Zimmer | {count} Zimmer",
    minStayTooltip: "Mindestaufenthalt: {count} Nacht | Mindestaufenthalt: {count} Nächte",
  },
  offBadge: "AUS",
  offTooltip: "Verkauf aus: Dieser Tarif wird auf keinem Kanal angeboten. Die übrigen Tarife des Zimmers werden weiter verkauft.",
  rateMenu: {
    open: "Tarifoptionen",
    minStay: "Mindestaufenthalt nach Datum",
    priceLabsMinStay: "Diesen Tarif verwaltet PriceLabs: Den Mindestaufenthalt legt PriceLabs fest.",
    stopSelling: "Verkauf dieses Tarifs stoppen",
    stopping: "Verkauf wird gestoppt…",
    resuming: "Verkauf wird reaktiviert…",
    resumeSelling: "Verkauf dieses Tarifs fortsetzen",
    derivedPriceHint: "Der Preis eines abgeleiteten Tarifs stammt vom Haupttarif",
    mainKeepsDerived: "Die abgeleiteten Tarife bleiben im Verkauf",
    mainNotYet: "Einen Haupttarif zu schließen ist noch nicht verfügbar",
  },
  derived: {
    badge: "A",
    tooltip: "Rate abgeleitet von: {parent}{rule}",
    rulePart: " · Regel: {rule}",
  },
  tooltips: {
    syncEnabled:
      "Berechnet Verfügbarkeit und Höchstaufenthalt neu und sendet sie erneut an die OTA (verhindert Überbuchungen).",
    syncDisabled: "Verbinden Sie die Unterkunft mit einem Kanal, um die Synchronisierung zu aktivieren.",
    toggleClosedOpen: "Geschlossen/offen umschalten",
    managedByPricelabs: "Von PriceLabs verwaltet",
    clickToEdit: "Zum Bearbeiten auswählen oder anklicken",
  },
  cellTitle: {
    pastDate: "Vergangenes Datum",
    closed: "Geschlossen (zum Öffnen klicken)",
    detail:
      "{free} frei · {tope} von {total} im Angebot · {booked} gebucht, zum Bearbeiten des Limits klicken",
  },
  soldBadge: {
    confirmed: "{real} bestätigte Buchungen",
    withOverbooking: "{real} bestätigt + {over} überbucht",
  },
  bulkModal: {
    from: "Von",
    to: "Bis",
    rangeHint:
      "Sie können den Zeitraum hier erweitern oder anpassen. (In der Ansicht wird nur der aktuelle Monat optisch aktualisiert.)",
    room: "Zimmer",
    whatToEdit: "Was bearbeiten",
    optAvail: "Verfügbarkeit und Schließungen",
    optRate: "Preise und Mindestaufenthalt",
    status: "Status",
    open: "Öffnen",
    close: "Schließen",
    cap: "Limit",
    availHint:
      "Das ist die Gesamtzahl, die Sie anbieten; Buchungen werden automatisch abgezogen und es werden nur freie Zimmer verkauft. Max. {max} (betriebsbereit, ohne Wartung).",
    mainRate: "Hauptrate",
    mainRateHint:
      "Wählen Sie die Hauptrate, die Sie ändern möchten; die abgeleiteten Raten passen sich automatisch an.",
    action: "Aktion",
    price: "Preis",
    minStay: "Mindestaufenthalt",
    minStayNights: "Mindestaufenthalt (Nächte)",
    minStayHelp: "1 = keine Einschränkung (leer)",
  },
  syncConfirm: {
    title: "Mit der OTA synchronisieren",
    message:
      "Dabei werden Verfügbarkeit und Höchstaufenthalt dieses Kalenders neu berechnet und erneut an die OTA gesendet.",
    confirm: "Ja, synchronisieren",
  },
  progress: {
    processing: "Wird verarbeitet…",
    syncing: "Kalender wird mit der OTA synchronisiert…",
    updatingAvail: "Verfügbarkeit wird aktualisiert…",
    updatingRate: "Rate wird aktualisiert…",
    applying: "Änderungen werden angewendet…",
    applyingBulk: "Sammelbearbeitung wird angewendet…",
    applyingIn: "Wird auf {name} angewendet…",
  },
  toasts: {
    noPropertyToSync: "Es gibt keine Unterkunft zum Synchronisieren.",
    syncOk: "Kalender neu berechnet und mit der OTA synchronisiert.",
    syncErr: "Der Kalender konnte nicht mit der OTA synchronisiert werden.",
    loadErr: "Die Hotelinformationen konnten nicht geladen werden.",
    maxAvailClosedBlocked:
      "Maximal verfügbar: {capacity} (es gibt geschlossene, gesperrte oder in Wartung befindliche Zimmer).",
    availUpdated: "Verfügbarkeit aktualisiert",
    availUpdateErr: "Die Verfügbarkeit konnte nicht aktualisiert werden",
    freeSuffix: " (frei: {free})",
    rateUpdated: "Rate aktualisiert",
    rateUpdateErr: "Die Rate konnte nicht aktualisiert werden",
    maxAvailMaintenance:
      "Maximal verfügbar: {capacity} (es gibt Zimmer in Wartung oder außer Betrieb).",
    noDatesModifiedBooked: "Es wurden keine Daten geändert: {count} mit Buchungen.",
    appliedFreeDates:
      "Auf die freien Daten angewendet. {count} Datum/Daten mit Buchungen wurden nicht geändert.",
    changesApplied: "Änderungen erfolgreich angewendet",
    savedNotSyncedYet: "Hier gespeichert, aber noch nicht bei den Vertriebskanälen angekommen. Der Versand wird in einigen Minuten wiederholt.",
    cannotEditDerivedPricelabs:
      "Eine abgeleitete oder von PriceLabs verwaltete Rate können Sie nicht bearbeiten.",
    minStayNumberGte1: "Der Mindestaufenthalt muss eine Zahl >= 1 sein.",
    invalidAction: "Ungültige Aktion.",
    applyErr: "Die Änderungen konnten nicht angewendet werden",
    noRoomsToEdit: "Es gibt keine Zimmer zum Bearbeiten.",
    selectAtLeastOneRoom: "Wählen Sie mindestens ein Zimmer aus.",
    chooseAction: "Wählen Sie eine Aktion.",
    selectDateRange: "Wählen Sie einen Zeitraum aus.",
    enterValidPrice: "Geben Sie einen gültigen Preis ein.",
    minStayGte1: "Der Mindestaufenthalt muss >= 1 sein.",
    appliedWithErrors: "Auf {ok} Zimmer angewendet. {failed} mit Fehler",
    noDatesModifiedCapacity:
      "Es wurden keine Daten geändert: An {count} Tag(en) war diese Zimmeranzahl nicht möglich.",
    bulkAppliedClamped:
      "Sammelbearbeitung auf {ok} Zimmer angewendet. An {clamped} Datum/Daten wurde sie auf die Anzahl der Zimmer im Betrieb angepasst.",
    bulkApplied: "Sammelbearbeitung auf {ok} Zimmer angewendet.",
    bulkApplyErr: "Die Sammelbearbeitung konnte nicht angewendet werden.",
    applyChangesErr: "Die Änderungen konnten nicht angewendet werden.",
  },
  // Decorative (aria-hidden) empty-state content
  ghost: {
    month: "MAI 2026",
    day1: "Mo 1",
    day2: "Di 2",
    day3: "Mi 3",
    day4: "Do 4",
    day5: "Fr 5",
    day6: "Sa 6",
    day7: "So 7",
    day8: "Mo 8",
    day9: "Di 9",
    day10: "Mi 10",
    day11: "Do 11",
    day12: "Fr 12",
    unit1: "Deluxe-Suite",
    unit1Rooms: "(2 Zimmer)",
    unit2: "Standardzimmer",
    unit2Rooms: "(3 Zimmer)",
    baseRate: "Basisrate",
    nonRefundable: "Nicht erstattbar",
  },
};
